import { Action } from '@/_core/fluxstore/types';
import { BoardActivityPanelState, BoardActivityItem } from '../types';
import { useBoardActivityStore } from '../useModule';

const { registerReducer } = useBoardActivityStore();

export class IncrementUnseenBoardActivityCount extends Action<BoardActivityPanelState> {
    public static ACTION_TYPE = 'BoardActivity::IncrementUnseenCount';

    constructor(public activity: BoardActivityItem) {
        super(IncrementUnseenBoardActivityCount.ACTION_TYPE);
    }
}

const reducer = (state: BoardActivityPanelState, action: IncrementUnseenBoardActivityCount): void => {
    if (state.realtimeCountedActivityIds.includes(action.activity.id)) {
        return;
    }

    state.unseenCount++;
    state.latestRelevantActivityId = action.activity.id;
    state.realtimeCountedActivityIds.unshift(action.activity.id);
    if (state.realtimeCountedActivityIds.length > 200) {
        state.realtimeCountedActivityIds.length = 200;
    }
};

//@ts-ignore
registerReducer(IncrementUnseenBoardActivityCount.ACTION_TYPE, reducer);
